<template>
  <v-dialog max-width="500" v-model="visible">
    <!-- <v-tooltip bottom> -->
    <template v-slot:activator="{ on }">
      <v-btn color="green" x-small dark fab v-on="on">
        <v-icon>print</v-icon>
      </v-btn>
    </template>

    <!-- Imprimir Documentación -->
    <!-- </v-tooltip> -->
    <v-card flat>
      <v-toolbar>
        <v-icon color="orange">print</v-icon>
        <v-toolbar-title class="font-weight-light">
          <v-row>
            <v-col>
              <div>&nbsp;Impresión de Formularios</div>
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="visible = false"><v-icon>close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-list dense>
            <v-list-item-group v-model="selectedFormularios" multiple>
              <template
                v-for="item in listaFormularios.filter(
                  (f) =>
                    !user.esComer ||
                    (this.checkCanAccess('ap-puede-ver-chequera') &&
                      f.descripcion.includes('Chequera')) ||
                    (!f.descripcion.includes('Chequera') &&
                      !f.descripcion.includes('Orden') &&
                      !f.descripcion.includes('Carátula'))
                )"
              >
                <v-list-item
                  :key="item.id"
                  :value="item"
                  active-class="deep-purple--text text--accent-4"
                >
                  <template v-slot:default="{ active, toggle }">
                    <v-list-item-action>
                      <v-checkbox
                        :input-value="active"
                        :true-value="item"
                        color="deep-purple accent-4"
                        @click="toggle"
                      ></v-checkbox>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title
                        v-text="item.descripcion"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          color="blue darken-1"
          text
          @click.stop="visible = false"
          :disabled="loading"
          >Cerrar</v-btn
        >
        <v-spacer></v-spacer>

        <v-btn
          color="blue darken-1"
          text
          @click.stop="imprimir()"
          :disabled="loading"
          >Imprimir</v-btn
        >
      </v-card-actions>
    </v-card>

    <app-loading :loading="loading"></app-loading>

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Model: {{ listaFormularios }}
      <p></p>
    </template>
  </v-dialog>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';

import { mapGetters, mapMutations } from 'vuex';

export default {
  data: () => ({
    loading: false,
    listaFormularios: [],
    showSelectorEmpresa: false,
    visible: false,
    selectedFormularios: [],
  }),
  props: {
    creditoId: { type: String },
    empresaId: { type: Number },
    productoDescripcion: { type: String, default: '' },
  },
  computed: {
    ...mapGetters([
      'getActionFromLink',
      'user',
      'DebugModeOn',
      'checkCanAccess',
    ]),
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
    esProductoDirigido: function() {
      return (
        this.productoDescripcion.toUpperCase().includes('DIRIGIDO') ||
        this.productoDescripcion.toUpperCase().includes('CONSUMO COMERCIO')
      );
    },
  },
  watch: {
    visible: function() {
      if (this.visible) {
        this.loadFormularios();
      }
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'setActiveSubTask',
      'hideActiveTask',
      'hideActiveSubTask',
      'setReporteActivo',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    async loadFormularios() {
      this.loading = true;
      var self = this;

      try {
        await http
          .get(
            'formulariosimpresion?empresaId=' +
              this.empresaId +
              '&creditoId=' +
              this.creditoId
          )
          .then((res) => {
            //       if(this.creditoId != null && this.empresaId == 1){
            //      let empresaFormularios = {
            //         id : 8,
            //        empresaId: 1,
            //       descripcion : 'Formulario Libre Deuda',
            //       nombreFormulario: 'LibreDeudaArgenCred.trdp'
            //   }
            //   res.list.push(empresaFormularios)
            //     }

            //   if(this.creditoId != null && this.empresaId == 2){
            // let empresaFormularios2 = {
            //     id : 9,
            //   empresaId: 2,
            //   descripcion : 'Formulario LibreDeuda',
            //   nombreFormulario: 'LibreDeudaFinadi.trdp'
            //  }
            //    res.list.push(empresaFormularios2)
            //   }

            //res.list.push(empresaFormularios,empresaFormularios2)

            self.listaFormularios = res.list;

            if (this.esProductoDirigido) {
              self.listaFormularios = self.listaFormularios.filter(
                (form) => form.id != 1 && form.id != 6
              );
            } else {
              self.listaFormularios = self.listaFormularios.filter(
                (form) => form.id != 7 && form.id != 8
              );
            }

            if (!this.checkCanAccess('ap-acceso-formularios-internos')) {
              self.listaFormularios = self.listaFormularios.filter(
                (form) => !form.descripcion.toUpperCase().includes('INTERN')
              );
            }
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async imprimir() {
      Vue.$log.debug(this.selectedFormularios);

      for (var i = 0; i < this.selectedFormularios.length; i++) {
        Vue.$log.debug(this.selectedFormularios[i].nombreFormulario);
        let formulario = this.selectedFormularios[i].nombreFormulario;
        let params = [];
        //Vue.$log.debug(this.creditoId);
        params.push({ CreditoId: this.creditoId });

        await this.setReporteActivo({ reporte: formulario, params: params });
        window.open('/report-viewer');
      }
    },
  },
};
</script>
